import * as React from "react";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export const MCButtonBV1 = ({
  variant = "text",
  title,
  onClick,
  size = "small",
  type,
  startIcon,
  endIcon,
  sx = { fontSize: "12px" },
  disabled,
  color,
  id,
}) => {
  return (
    <Button
      id={id}
      variant={variant}
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      sx={sx}
      type={type}
      disabled={disabled}
      color={color}
      autoFocus
    >
      {title}
    </Button>
  );
};

export function MCTextButtonBV2({
  onClick,
  text,
  variant = "body2",
  underline = "hover",
  color = "primary",
  sx ,
  disabled,
  description = "",
}) {
  return (
    <Box sx={{ display: "flex", columnGap: "4px" }} component={"section"}>
      {description && (
        <Typography sx={{ fontSize: "14px" }}>{description}</Typography>
      )}
      <Link
        component="button"
        variant={variant}
        underline={underline}
        onClick={onClick}
        color={color}
        sx={sx}
        disabled={disabled}
      >
        {text}
      </Link>
    </Box>
  );
}

export function MCButtonPickerDateBV3({ icon, onClick, sx, size = "small" }) {
  return (
    <IconButton onClick={onClick} sx={sx} size={size}>
      {icon}
    </IconButton>
  );
}
